// 260703nrai: dynamic recipient filters for messages/new
function initMessagesCompose() {
  const graphNode = document.getElementById('messages_recipient_graph');
  const initialNode = document.getElementById('messages_initial_selection');
  if (!graphNode) return;

  const graph = JSON.parse(graphNode.textContent || '{}');
  const initialSelection = JSON.parse(initialNode?.textContent || '{}');

  const $roleSelect = $('#to_user_roles');
  const $domainSelect = $('#to_domains');
  const $institutionSelect = $('#to_institutions');
  const $personSelect = $('#to_user_ids');
  const $summary = $('#messages_compose_summary');
  const $resetLink = $('.messages-compose-reset-filters');

  let filters = {
    user_roles: (initialSelection.user_roles || []).map(String),
    domains: (initialSelection.domains || []).map(String),
    institutions: (initialSelection.institutions || []).map(String)
  };
  let selectedUserIds = (initialSelection.user_ids || []).map(String);
  let suppressPersonChange = false;
  let suppressFilterChange = false;

  function initSelect2($element) {
    $element.select2({
      width: '100%',
      allowClear: true,
      placeholder: '—'
    });
  }

  initSelect2($roleSelect);
  initSelect2($domainSelect);
  initSelect2($institutionSelect);
  initSelect2($personSelect);

  function personMatchesFilters(person) {
    const roleOk = !filters.user_roles.length || filters.user_roles.some((code) => person.user_roles.includes(code));
    const domainOk = !filters.domains.length || filters.domains.some((id) => person.domain_groups.map(String).includes(String(id)));
    const institutionOk = !filters.institutions.length || filters.institutions.some((id) => person.institutions.map(String).includes(String(id)));
    return roleOk && domainOk && institutionOk;
  }

  function matchingPeople() {
    return (graph.employees || []).filter(personMatchesFilters);
  }

  function hasAnyFilter() {
    return !!(filters.user_roles.length || filters.domains.length || filters.institutions.length);
  }

  function updateResetLinkVisibility() {
    if (hasAnyFilter()) {
      $resetLink.show();
    } else {
      $resetLink.hide();
    }
  }

  function availableOptions(kind, selectedValues) {
    const otherFilters = { ...filters };
    otherFilters[kind] = [];

    const people = (graph.employees || []).filter((person) => {
      const roleOk = !otherFilters.user_roles.length || otherFilters.user_roles.some((code) => person.user_roles.includes(code));
      const domainOk = !otherFilters.domains.length || otherFilters.domains.some((id) => person.domain_groups.map(String).includes(String(id)));
      const institutionOk = !otherFilters.institutions.length || otherFilters.institutions.some((id) => person.institutions.map(String).includes(String(id)));
      return roleOk && domainOk && institutionOk;
    });

    const values = new Set();
    people.forEach((person) => {
      if (kind === 'user_roles') person.user_roles.forEach((code) => values.add(code));
      if (kind === 'domains') person.domain_groups.forEach((id) => values.add(String(id)));
      if (kind === 'institutions') person.institutions.forEach((id) => values.add(String(id)));
    });

    selectedValues.forEach((value) => values.add(String(value)));

    const catalog = kind === 'user_roles' ? graph.user_roles : kind === 'domains' ? graph.domain_groups : graph.institutions;
    return (catalog || []).filter((entry) => values.has(String(entry.id)));
  }

  function rebuildFilterSelect($select, options, selected) {
    const current = (selected || $select.val() || []).map(String);
    $select.empty();
    options.forEach((option) => {
      $select.append(new Option(option.name, option.id, false, current.includes(String(option.id))));
    });
    $select.val(current);
    $select.trigger('change.select2');
  }

  function refreshFilterOptions() {
    suppressFilterChange = true;
    rebuildFilterSelect($roleSelect, availableOptions('user_roles', filters.user_roles), filters.user_roles);
    rebuildFilterSelect($domainSelect, availableOptions('domains', filters.domains), filters.domains);
    rebuildFilterSelect($institutionSelect, availableOptions('institutions', filters.institutions), filters.institutions);
    suppressFilterChange = false;
  }

  function rebuildPersonOptions() {
    const people = matchingPeople();
    const allowedIds = new Set(people.map((person) => String(person.user_id)));
    selectedUserIds = selectedUserIds.filter((id) => allowedIds.has(String(id)));

    suppressPersonChange = true;
    $personSelect.empty();
    people.forEach((person) => {
      $personSelect.append(new Option(`${person.name} (${person.username})`, person.user_id, false, selectedUserIds.includes(String(person.user_id))));
    });
    $personSelect.val(selectedUserIds).trigger('change.select2');
    suppressPersonChange = false;
  }

  // 260805nrai: enable "Todo für EmpfängerIn" only with exactly one recipient
  function updateCreateTodoCheckbox() {
    const $checkbox = $('#create_todo_for_recipient');
    if (!$checkbox.length) return;

    const singleRecipient = selectedUserIds.length === 1;
    $checkbox.prop('disabled', !singleRecipient);
    if (!singleRecipient) {
      $checkbox.prop('checked', false);
    }
  }

  function updateSummary() {
    const ids = selectedUserIds.map((id) => parseInt(id, 10)).filter(Boolean);
    const filtersPayload = {
      user_roles: filters.user_roles,
      domains: filters.domains.map((id) => parseInt(id, 10)),
      institutions: filters.institutions.map((id) => parseInt(id, 10))
    };

    updateCreateTodoCheckbox();

    if (!ids.length) {
      $summary.text('Bitte EmpfängerIn auswählen.');
      return;
    }

    if (ids.length === 1) {
      const person = (graph.employees || []).find((entry) => String(entry.user_id) === String(ids[0]));
      $summary.text(person ? `Nachricht an ${person.name}` : 'Nachricht an 1 EmpfängerIn');
      return;
    }

    const filterParts = [];
    if (filters.user_roles.length) {
      const names = (graph.user_roles || []).filter((role) => filters.user_roles.includes(String(role.id))).map((role) => role.name);
      if (names.length) filterParts.push(`der Benutzergruppe ${names.join(', ')}`);
    }
    if (filters.domains.length) {
      const names = (graph.domain_groups || []).filter((domain) => filters.domains.includes(String(domain.id))).map((domain) => domain.name);
      if (names.length) filterParts.push(`des Bereichs ${names.join(', ')}`);
    }
    if (filters.institutions.length) {
      const names = (graph.institutions || []).filter((inst) => filters.institutions.includes(String(inst.id))).map((inst) => inst.name);
      if (names.length) filterParts.push(`der Einrichtung ${names.join(', ')}`);
    }

    const matchingIds = matchingPeople().map((person) => String(person.user_id)).sort();
    const selectedSorted = [...selectedUserIds].sort();
    const allMatch = matchingIds.length === selectedSorted.length && matchingIds.every((id, index) => id === selectedSorted[index]);

    if (filterParts.length && allMatch) {
      $summary.text(`Nachricht an alle ${ids.length} Personen ${filterParts.join(' ')}`);
    } else if (filterParts.length) {
      $summary.text(`Nachricht an ${ids.length} Personen ${filterParts.join(' ')}`);
    } else if (ids.length <= 2) {
      const labels = ids.map((id) => {
        const person = (graph.employees || []).find((entry) => String(entry.user_id) === String(id));
        return person ? `(${person.username})` : '';
      }).filter(Boolean);
      $summary.text(`Nachricht an ${labels.join(' ')}`);
    } else {
      const firstTwo = ids.slice(0, 2).map((id) => {
        const person = (graph.employees || []).find((entry) => String(entry.user_id) === String(id));
        return person ? `(${person.username})` : '';
      }).filter(Boolean);
      $summary.text(`Nachricht an ${firstTwo.join(' ')} + ${ids.length - 2} weitere`);
    }
  }

  function syncFiltersFromDom() {
    filters.user_roles = ($roleSelect.val() || []).map(String);
    filters.domains = ($domainSelect.val() || []).map(String);
    filters.institutions = ($institutionSelect.val() || []).map(String);
    updateResetLinkVisibility();
  }

  function onFilterChange() {
    if (suppressFilterChange) return;
    syncFiltersFromDom();
    refreshFilterOptions();
    if (hasAnyFilter()) {
      selectedUserIds = matchingPeople().map((person) => String(person.user_id));
    }
    rebuildPersonOptions();
    updateSummary();
  }

  $roleSelect.add($domainSelect).add($institutionSelect).on('change', onFilterChange);

  $personSelect.on('change', function () {
    if (suppressPersonChange) return;
    selectedUserIds = ($personSelect.val() || []).map(String);
    updateSummary();
  });

  $('.messages-compose-select-all').on('click', function (event) {
    event.preventDefault();
    selectedUserIds = matchingPeople().map((person) => String(person.user_id));
    suppressPersonChange = true;
    $personSelect.val(selectedUserIds).trigger('change.select2');
    suppressPersonChange = false;
    updateSummary();
  });

  $('.messages-compose-select-none').on('click', function (event) {
    event.preventDefault();
    selectedUserIds = [];
    suppressPersonChange = true;
    $personSelect.val([]).trigger('change.select2');
    suppressPersonChange = false;
    updateSummary();
  });

  $('.messages-compose-reset-filters').on('click', function (event) {
    event.preventDefault();
    filters = { user_roles: [], domains: [], institutions: [] };
    suppressFilterChange = true;
    $roleSelect.val([]).trigger('change.select2');
    $domainSelect.val([]).trigger('change.select2');
    $institutionSelect.val([]).trigger('change.select2');
    suppressFilterChange = false;
    selectedUserIds = [];
    refreshFilterOptions();
    rebuildPersonOptions();
    updateSummary();
    updateResetLinkVisibility();
  });

  if (filters.user_roles.length || filters.domains.length || filters.institutions.length) {
    suppressFilterChange = true;
    $roleSelect.val(filters.user_roles).trigger('change.select2');
    $domainSelect.val(filters.domains).trigger('change.select2');
    $institutionSelect.val(filters.institutions).trigger('change.select2');
    suppressFilterChange = false;
  }

  refreshFilterOptions();
  rebuildPersonOptions();

  if (selectedUserIds.length) {
    suppressPersonChange = true;
    $personSelect.val(selectedUserIds).trigger('change.select2');
    suppressPersonChange = false;
  }

  updateSummary();
  updateResetLinkVisibility();
}

// 260902nrai: SA/AD raw-HTML textarea instead of Froala/TinyMCE
function messageBodyTextarea() {
  return document.getElementById('message_messagetext');
}

function messageFroalaEditor() {
  if (window.editorMessagemessagetext) return window.editorMessagemessagetext;
  if (window.FroalaEditor && FroalaEditor.INSTANCES) {
    const textarea = messageBodyTextarea();
    const instances = FroalaEditor.INSTANCES;
    const list = Array.isArray(instances) ? instances : Object.values(instances);
    return list.find((inst) => {
      const el = inst && (inst.$oel && inst.$oel[0] || inst.el);
      return el && textarea && el === textarea;
    }) || null;
  }
  return null;
}

function disableMessageWysiwyg() {
  const froala = messageFroalaEditor();
  if (froala && typeof froala.destroy === 'function') {
    window.messagesFroalaOpts = froala.opts;
    try { froala.destroy(); } catch (e) { /* ignore */ }
    window.editorMessagemessagetext = null;
  }
  if (window.tinymce && typeof tinymce.get === 'function') {
    const editor = tinymce.get('message_messagetext');
    if (editor && typeof editor.remove === 'function') {
      editor.remove();
    }
  }
}

function enableMessageWysiwyg() {
  const textarea = messageBodyTextarea();
  if (!textarea) return;

  if (window.FroalaEditor && window.messagesFroalaOpts) {
    window.editorMessagemessagetext = new FroalaEditor('#message_messagetext', window.messagesFroalaOpts);
    return;
  }
  if (window.tinymce && typeof tinymce.init === 'function' && textarea.classList.contains('tinymce')) {
    tinymce.init({ selector: '#message_messagetext' });
  }
}

function setMessageRawHtmlMode(raw) {
  const wrap = document.querySelector('.messages-compose-editor-wrap');
  const toggle = document.getElementById('messages_compose_raw_html_toggle');
  const textarea = messageBodyTextarea();
  if (!textarea) return;

  if (raw) {
    disableMessageWysiwyg();
    textarea.classList.add('messages-compose-raw-textarea');
    textarea.removeAttribute('disabled');
    if (wrap) wrap.classList.add('is-raw');
    if (toggle) {
      toggle.textContent = 'Editor';
      toggle.setAttribute('title', 'Wieder den Editor anzeigen');
      toggle.dataset.raw = '1';
    }
  } else {
    textarea.classList.remove('messages-compose-raw-textarea');
    if (wrap) wrap.classList.remove('is-raw');
    enableMessageWysiwyg();
    if (toggle) {
      toggle.textContent = 'Raw-HTML';
      toggle.setAttribute('title', 'Statt Editor ein Textfeld für HTML anzeigen');
      toggle.dataset.raw = '0';
    }
  }
}

function initMessagesRawHtml() {
  const toggle = document.getElementById('messages_compose_raw_html_toggle');
  if (!toggle) return;

  toggle.addEventListener('click', function (event) {
    event.preventDefault();
    const rawOn = toggle.dataset.raw === '1';
    setMessageRawHtmlMode(!rawOn);
  });
}

window.initMessagesCompose = initMessagesCompose;
window.initMessagesRawHtml = initMessagesRawHtml;

export { initMessagesCompose, initMessagesRawHtml };
